define('LNRS/Components/Social/SocialEmail',["jquery", "eventManager"], function ($, eventManager) {
    function SocialEmail(scope) {
        eventManager.subscribe("SiteSharingDataLoaded", function (socailSharingData) {
            var fullUrl = '';
            $.each(socailSharingData, function(index, socialNetworkData) {
                if (socialNetworkData.Name.indexOf('Email') != -1) {
                    fullUrl = socialNetworkData.FullUrl;
                }
            });
            if (fullUrl.length > 0) {
                $('#social-share-mail-link').attr('href', fullUrl);
            }
        }.bind(this));
    }

    return function init(args) {
        return new SocialEmail(args.scope);
    };
});
